import * as Sentry from '@sentry/browser'

if (process.env.NODE_ENV == 'production') {
  Sentry.init({
    dsn: 'https://1789f1a5a97047cdb5b220b65ba5999d@sentry.io/1864051',
    release: `pitcher-impact-live-web@${process.env.VUE_APP_VERSION}`,
    tracesSampleRate: 1.0,
  })
}
